import { useCheckoutContext } from "./Checkout.hooks";

export default function CheckoutEmpty() {
  const { dictionary } = useCheckoutContext();

  return <p className="px-6 py-8 text-xl">{dictionary?.noItemsInCart}</p>;
}
